import { Dispatch } from "@reduxjs/toolkit";

import {
    setIsInternalModification,
    setNextWorkflowStep,
} from "@components/OrderTaking/Store/feature";

export function goToNextStep(
    // eslint-disable-next-line
    workflowData: any,
    // eslint-disable-next-line
    dispatch: Dispatch<any>
): void {
    if (workflowData?.length === 1) {
        dispatch(setIsInternalModification(false));
    }
    dispatch(setNextWorkflowStep());
}
